import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { API_KEY, BASE_URL } from "./config";

Modal.setAppElement('#root');

function RepelTradeModal({ isOpen, closeModal }) {
  const [formData, setFormData] = useState({
    account: 'mani1140',
    symbol: '',
  });
  const [symbols, setSymbols] = useState([]); // Stores multiple symbols
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [submissionResult, setSubmissionResult] = useState(null);

  const fetchRepelTradeSymbols = async () => {
    try {
      const account = 'mani1140';
      const response = await fetch(`${BASE_URL}/api/bot/ui/post/getRepelTradeSymbolByAccount?account=${account}`,
                      {
                        headers: {
                          "X-SIGNALFLY-KEY": API_KEY
                        }
                      });
      const data = await response.json();
      if (data && Array.isArray(data)) {
        // Extract the symbol from each object and filter out any null or undefined symbols
        const symbolList = data.map(item => item.symbol).filter(symbol => symbol);
        setSymbols(symbolList);
      } else {
        setSymbols([]);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchRepelTradeSymbols(); 
  }, []);



  const handleAddSymbol = () => {
    setLoading(true);
    repelTradePost(formData);
  };

  const handleDeleteSymbol = () => {
    setLoading(true);
    if (!formData.symbol) {
      setError("No symbol selected");
      setLoading(false);
      return;
    }
    repelTradeDelete(formData);
  };

  const renderSymbolOptions = () => {
    return symbols && symbols.map((symbol, index) => (
      <option key={index} value={symbol}>{symbol}</option>
    ));
  };



  const repelTradePost = (formSubmittedData) => {
    setLoading(true);
    fetch(`${BASE_URL}/api/bot/ui/post/saveRepelTradeSymbol`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      },
      body: JSON.stringify(formSubmittedData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setSubmissionResult(data);
      setLoading(false);
      closeModal();
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
    });
  };

  const repelTradeDelete = (formSubmittedData) => {
    fetch(`${BASE_URL}/api/bot/ui/post/deleteRepelTradeSymbolBySymbolAndAccount?account=${formSubmittedData.account}&symbol=${formSubmittedData.symbol}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      setSubmissionResult(data);
      setLoading(false);
      // Refresh the symbols list
      fetchRepelTradeSymbols();
      closeModal();
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
};




  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Repel Trade Symbol"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
    <button className="modal-close-button" onClick={closeModal}>&times;</button>
    <h2 className="page-title">Repel Trade Symbols</h2>
      <br/>
      {loading && <div className="loading-message">Processing...</div>}
      {error && <div>Error: {error}</div>}
      {submissionResult && <div>Result: {JSON.stringify(submissionResult)}</div>}
      {!loading && !submissionResult && (
        <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
         <label>
          Account:
          <input
            type="text"
            name="account"
            value={formData.account}
            readOnly
          />
        </label>
          <label>
            Symbol:
            <select name="symbol" value={formData.symbol} onChange={handleInputChange}>
              {renderSymbolOptions()}
            </select>
          </label>
          <input
            type="text"
            placeholder="Add new symbol or Delete symbol"
            onChange={(e) => setFormData({ ...formData, symbol: e.target.value })}
          />
          <div className="modal-button-container">
            <button type="button" onClick={handleAddSymbol}>Add Symbol</button>
            <button type="button" onClick={handleDeleteSymbol}>Delete Symbol</button>
            <button type="button" onClick={closeModal}>Cancel</button>
          </div>
        </form>
      )}
    </Modal>
  );
}

export default RepelTradeModal;
